import { getOssObj } from "../service/register";

const oss = {
  name: "oss",
  state: {}, // initial state
  reducers: {
    setOssObj(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
    clearInfo() {
      return {};
    },
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async setOssAsync(param) {
      const info = await getOssObj(param);
      this.setOssObj(info);
      return info
    },
  }),
};

export default oss;
